/**
 * @generated SignedSource<<00025077ed86bee402746dcc7ff7c195>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendMarketingEmailTestEmailDialogMeQuery$variables = Record<PropertyKey, never>;
export type SendMarketingEmailTestEmailDialogMeQuery$data = {
  readonly me: {
    readonly email: string;
  } | null | undefined;
};
export type SendMarketingEmailTestEmailDialogMeQuery = {
  response: SendMarketingEmailTestEmailDialogMeQuery$data;
  variables: SendMarketingEmailTestEmailDialogMeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SendMarketingEmailTestEmailDialogMeQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SendMarketingEmailTestEmailDialogMeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ebdaafbe99aaeda89fa415c587b0af84",
    "id": null,
    "metadata": {},
    "name": "SendMarketingEmailTestEmailDialogMeQuery",
    "operationKind": "query",
    "text": "query SendMarketingEmailTestEmailDialogMeQuery {\n  me {\n    email\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd914b028f4f7fe26b9b169d8dbfa8f2";

export default node;
